import React from "react";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom";
import { AuthService, ContactService } from "../../../shared/services";
import {
  CustomLabel,
  FlexContainer,
  ModalComponent,
  RedButton,
  ToastService,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { ContactDetailPageModel } from "../../../shared/models";

type IProps = {
  navigate: NavigateFunction;
  onClose: (refresh: boolean) => void;
  contactsData: ContactDetailPageModel;
};

const DeleteCustomerPopup: React.FC<IProps> = ({ onClose, contactsData }) => {
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);

  function onDelete() {
      if (isAPIRequestPending) return;

      setAPIRequestPending(true);
      ContactService.deleteContact(AuthService.authData.accountId, contactsData.detail.id).subscribe({
          next: (response) => {
              setAPIRequestPending(false);
              if (response.result.success) {
                  ToastService.showSuccess('Contact Deleted Successfully');
              }
              onClose(true);
          },
          error: () => {
              setAPIRequestPending(false);
              ToastService.showError('Error in deleting contact');
          },
      });
  }

  const renderActivityItem = (label: string, count: number) => (
      <CustomLabel>{count > 0 ? `${count} ${label}${count === 1 ? '' : 's'}` : `0 ${label}s`}</CustomLabel>
  );

  const renderContent = () => {
      return (
          <FlexContainer fxLayout="column" spacing={30}>
              <FlexContainer spacing={15}>
                  <FlexContainer fxLayout="column" spacing={20}>
                      <CustomLabel fontWeight={'bold'}>Contact</CustomLabel>
                      <FlexContainer fxLayout="column" spacing={10}>
                          <CustomLabel>
                              {contactsData.detail.firstName} {contactsData.detail.lastName}
                          </CustomLabel>
                      </FlexContainer>
                  </FlexContainer>
                  <FlexContainer fxLayout="column" spacing={20}>
                      <CustomLabel fontWeight={'bold'}>Activity</CustomLabel>
                      <FlexContainer fxLayout="column" spacing={10}>
                          {renderActivityItem('Invoice', contactsData.invoices.length)}
                          {renderActivityItem('Order', contactsData.orders.length)}
                          {renderActivityItem('Payment Method', contactsData.paymentMethods.length)}
                          {renderActivityItem('Payment', contactsData.payments.length)}
                          {renderActivityItem('Subscription', contactsData.subscriptions.length)}
                      </FlexContainer>
                  </FlexContainer>
              </FlexContainer>
              <CustomLabel color="#FF0000" textAlign="center">
                  You will lose access to existing financial activity including Orders, Invoices, Payments, Payment
                  Methods and more.
              </CustomLabel>
          </FlexContainer>
      );
  };

  return (
      <ModalComponent
          title={'Delete Customer'}
          titleFontSize="22px"
          bodyPadding="40px 70px"
          onClose={() => onClose && onClose(false)}
          showFooter={true}
          wrapperWidth="600px"
          bodyBackgroundColor="#F4F7FB"
          footerHeight="auto"
          redHeader={true}
          blueHeader={false}
          footerContent={
              <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
                  <RedButton lineHeight="13px" minWidth="120px" height="30px" onClick={() => onClose(false)}>
                      Do not Delete
                  </RedButton>
                  <RedButton
                      lineHeight="13px"
                      primary
                      disabled={isAPIRequestPending}
                      minWidth="120px"
                      height="30px"
                      onClick={() => onDelete()}
                  >
                      Delete
                  </RedButton>
              </FlexContainer>
          }
      >
          {renderContent()}
      </ModalComponent>
  );
};

export default withRouter(observer(DeleteCustomerPopup));
